<template>
  <div>
   <div class="section register wf-section">
    <div id="join-moijoy-container" class="container register">
      <div class="join-us-cta">
        <h1 class="no-top-margin">Congratulations! Sign up as official Moijoy creator.</h1>
        <p>Please sign up with your phone number to register your official creator account. Please don&#x27;t share this form with other creators directly.</p>
        <div class="form-container-register">
          <div id="recaptcha-container"></div><br>
          <div class="register-form w-form">
            <div id="wf-form-request-code" name="wf-form-request-code" class="email-solo-form">
              <input type="tel" v-model="phNo" class="input-field w-input" placeholder="+31" required="">
              <div @click="sendOtp" id="sign-in-button" class="gradient-button w-button">
                <span id="button-text-request">Request code</span>
                <img id="loading-gif-request" src="https://c.tenor.com/5o2p0tH5LFQAAAAj/hug.gif" alt="loading gif" width="24" height="24" style="margin-bottom: -6px;">
              </div>
            </div>
          </div>
          <div class="register-form w-form">
            <div id="wf-form-verify-code" name="wf-form-verify-code" class="email-solo-form">
              <input type="number" v-model="otp" class="input-field w-input" maxlength="6" name="verifyCode" placeholder="Verification code" id="verifyCode" required="">
              <div  @click="verifyOtp" class="gradient-button w-button">
                <span id="button-text-verify"> Verify code</span>
                <img id="loading-gif-verify" src="https://c.tenor.com/5o2p0tH5LFQAAAAj/hug.gif" alt="loading gif" width="24" height="24" style="margin-bottom: -6px;">
              </div>
            </div>
          </div>
        </div>
        <!-- <button @click="sendOtp()">Resend OTP</button> -->
      </div>
    </div>
  </div>
    </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data(){
      return{
        phNo: '',
        appVerifier : '',
        otp : ''
      }
    },
    methods :{
      sendOtp(){
        if(this.phNo.length > 15){
          alert('Invalid Phone Number Format !');
        }else{

          document.getElementById('loading-gif-request').style.display = 'block';
          document.getElementById('button-text-request').style.display = 'none';
          //
          let phoneNumber = this.phNo
          //
          let appVerifier = this.appVerifier
          //
          firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
            .then(function (confirmationResult) {
              // SMS sent. Prompt user to type the code from the message, then sign the
              // user in with confirmationResult.confirm(code).
              window.confirmationResult = confirmationResult;

              console.log(confirmationResult);
              //
              alert('SMS sent')
              document.getElementById('wf-form-request-code').style.display = 'none';
              document.getElementById('wf-form-verify-code').style.display = 'flex';
            }).catch(function (error) {
            // Error; SMS not sent
            console.log(error);
            alert('Error ! SMS not sent')
          });
        }
      },
      //
      verifyOtp(){
        if(this.phNo.length > 15 || this.otp.length != 6){
          alert('Invalid Phone Number/OTP Format !');
        }else{

          document.getElementById('loading-gif-verify').style.display = 'block';
          document.getElementById('button-text-verify').style.display = 'none';
          //
          let vm = this
          let code = this.otp
          //
          window.confirmationResult.confirm(code).then(function (result) {
            // User signed in successfully.
            var user = result.user;

            //route to set password !
            vm.$router.push({path:'/profile-setup'})
          }).catch(function (error) {
            // User couldn't sign in (bad verification code?)
            // ...
          });
        }
      },
      initReCaptcha(){
        setTimeout(()=>{
          let vm = this
          window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
            'size': 'invisible',
            'callback': function(response) {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              // ...
            },
            'expired-callback': function() {
              // Response expired. Ask user to solve reCAPTCHA again.
              // ...
            }
          });
          //
          this.appVerifier =  window.recaptchaVerifier
        },1000)
      }
    },
    created(){
      this.initReCaptcha()
    }
  }
</script>

<style scoped>
#loading-gif-request, #loading-gif-verify{
  display: none;  
}
</style>


// WEBPACK FOOTER //
// src/components/signup.vue